export default __webpack_public_path__ + "static/media/Sealread.0f07acf5.png";